import { render } from "./security-alert-view.vue?vue&type=template&id=57e09eb6&scoped=true&ts=true"
import script from "./security-alert-view.vue?vue&type=script&lang=ts"
export * from "./security-alert-view.vue?vue&type=script&lang=ts"

import "./security-alert-view.vue?vue&type=style&index=0&id=57e09eb6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e09eb6"]])

export default __exports__